import * as React from 'react';

import type { IconProps } from './types';

export const H2 = React.forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <g clipPath="url(#clip0_300_40)">
      <path
        d="M8.83333 0.472656C8.39474 0.472656 7.95614 0.508424 7.53509 0.579959V5.01513H3.11403V0.579959C2.64035 0.508424 2.20175 0.472656 1.76316 0.472656C1.32456 0.472656 0.903509 0.508424 0.5 0.579959V12.0434C0.95614 12.115 1.37719 12.1507 1.81579 12.1507C2.25439 12.1507 2.69298 12.115 3.11403 12.0434V7.4652H7.53509V12.0434C8.00877 12.115 8.44737 12.1507 8.88596 12.1507C9.32456 12.1507 9.74561 12.115 10.1667 12.0434V0.579959C9.69298 0.508424 9.27193 0.472656 8.83333 0.472656Z"
        fill={color}
      />
      <path
        d="M12.008 4.15063C11.936 4.39063 11.9 4.66663 11.888 4.91863C11.888 5.20663 11.936 5.47063 12.008 5.75863H14.78L13.412 7.42663C13.268 7.59463 13.184 7.75063 13.184 7.95463C13.184 8.01463 13.196 8.08663 13.22 8.15863H14.06C15.224 8.15863 15.668 8.57863 15.668 9.34663C15.668 10.1506 15.14 10.5466 14.36 10.5466C13.748 10.5466 13.22 10.2106 12.8 9.80263C12.26 10.1026 11.888 10.5586 11.72 11.1226C12.116 11.5426 13.016 12.1426 14.36 12.1426C16.016 12.1426 17.504 11.3146 17.504 9.27463C17.504 7.70263 16.4 7.13863 15.572 6.99463L16.904 5.49463C17.24 5.11063 17.312 4.60663 17.264 4.15063H12.008Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_300_40">
        <rect width="18" height="12" fill="white" transform="translate(0 0.150635)" />
      </clipPath>
    </defs>
  </svg>
));

export default H2;
